<script lang="ts" setup>
import AppSidebar from '@/components/AppSidebar.vue';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import BreadcrumbWrapper from '@/components/BreadcrumbWrapper.vue';
</script>

<template>
  <SidebarProvider>
    <AppSidebar />
    <div class="flex-1 min-w-0 overflow-hidden">
      <header
        class="flex h-16 shrink-0 items-center transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12 text-muted-foreground"
      >
        <div class="flex items-center">
          <SidebarTrigger class="ml-2 mr-2" />
          <span class="inline-block h-4 w-px bg-border mr-3.5 self-center" aria-hidden="true"></span>
          <BreadcrumbWrapper />
        </div>
      </header>
      <main class="flex flex-1 flex-col pt-0 min-w-0 h-[calc(100vh-64px)] overflow-x-auto">
        <slot />
      </main>
    </div>
  </SidebarProvider>
</template>
